<template>
  <div class="link-views white-bg">
    <div class="select-div">
      <div class="mr">
        <span>选择班级：</span>
        <i-select v-model="pageData.ClassId" style="width:200px">
          <i-option
            v-for="item in ClassArr"
            :value="item.ClassId"
            :key="item.ClassId"
          >{{ item.ClassName }}</i-option>
        </i-select>
      </div>
      <div class="mr">
        <span>选择实验：</span>
        <i-select v-model="pageData.ExpID" style="width:200px">
          <i-option
            v-for="item in ExperimentList"
            :value="item.ExpID"
            :key="item.ExpID"
          >{{ item.ExpName }}</i-option>
        </i-select>
      </div>
      <div>
        <Button
          type="primary"
          class="mr"
          icon="md-search"
          @click="searchById(pageData.ClassId,pageData.ExpID)"
        >查询</Button>
        <Button type="primary" class="mr" icon="md-refresh" @click="searchById(0,0)">重置</Button>
        <!-- <Button type="primary" icon="ios-download-outline" @click="exportData">批量导出</Button> -->
        <Button type="primary" icon="ios-download-outline" @click="downFun">批量导出</Button>
      </div>
    </div>

    <div class="table-div">
      <!-- 表格 -->
      <Table ref="table" :columns="columns" :data="listObj.Result" :loading="loading">
        <template slot-scope="{ row }" slot="IsSubmit">
          <span v-if="row.IsSubmit!=0">已提交</span>
          <span v-else class="error">未提交</span>
        </template>
        <template slot-scope="{ row }" slot="IsType">
          <span v-if="row.IsType">已批阅</span>
          <span v-else class="error">未批阅</span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <div class="action-table">
            <div class="action-table" v-if="row.IsSubmit==1">
              <a v-if="row.IsType" @click="showItemFn(row,false)">查看</a>
              <a v-else @click="showItemFn(row,true)">批阅</a>
            </div>
            <div class="action-table" v-else>
              <span>——</span>
            </div>
          </div>
        </template>
      </Table>
      <!-- 分页 -->
      <div class="page-div">
        <Page
          show-total
          :total="listObj.records"
          :current="pageData.page"
          :page-size="pageData.size"
          @on-change="changePage"
        />
      </div>
    </div>
    <Modal v-model="showModalExcl" :mask-closable="false">
      <Form ref="editItemExl" :model="editItemExl" :label-width="110">
        <FormItem label="班级选择：" prop="ClassId">
          <i-select v-model="editItemExl.ClassId" style="width:200px">
            <i-option
              v-for="item in ClassArr"
              :value="item.ClassId"
              :key="item.ClassId"
            >{{ item.ClassName }}</i-option>
          </i-select>
        </FormItem>
        <FormItem label="实验选择：" prop="ExpID">
          <i-select v-model="editItemExl.ExpID" style="width:200px">
            <i-option
              v-for="item in ExperimentList"
              :value="item.ExpID"
              :key="item.ExpID"
            >{{ item.ExpName }}</i-option>
          </i-select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="showModalExcl = false">取消</Button>
        <Button type="primary" @click="sureEditExl('editItemExl')">确定</Button>
      </div>
    </Modal>

    <!-- 编辑模态框 -->
    <Modal
      v-model="showModal"
      fullscreen
      title="实验报告点评"
      :mask-closable="false"
      :class="{'myfullscreen':true,'nofooter':true,'noLeft':isCollapsed }"
    >
      <div v-if="showDetails" class="reportList">
        <div v-for="(item,index) in arr" :key="index">
          <div class="title">
            <strong>{{item.title}}</strong>
          </div>
          <div class="info">
            <div v-if="editItem[item.name]">
              <div class="showDetails" v-html="editItem[item.name]"></div>
              <div v-if="showDetails" class="showDetails">
                <Button
                  type="text"
                  icon="ios-info"
                  v-if="item.isReport"
                  @click="doReport(item.Reportname)"
                >点评</Button>
              </div>
            </div>

            <div v-else>暂无数据</div>
          </div>
          <div
            class="report"
            v-if="item.isReport&&editItem[item.Reportname]"
          >点评：{{editItem[item.Reportname]}}</div>
          <div class="flexDiv" v-if="item.isReport&&activeName==item.Reportname">
            <Input
              v-model="submitObj[item.Reportname]"
              type="textarea"
              :rows="3"
              :placeholder="'点评'+item.title"
              class="flex1"
            />
            <div class="ml">
              <Button type="primary" @click="appendSubmit(item.Reportname)">确定</Button>
            </div>
          </div>
        </div>
        <div>
          <!-- sureEdit -->
          <strong class="mr">报告得分：</strong>
          <InputNumber
            style="border:1px solid #333333"
            class="mr"
            :max="100"
            :min="1"
            v-model="submitObj.ExpReportScore"
          ></InputNumber>
          <Button type="primary" @click="sureEdit">提交点评与得分</Button>
        </div>
      </div>
      <div v-else>
        <div class="text-right">
          <Button type="primary" @click="downloadWord">下载为Word</Button>
        </div>
        <div id="reportList" class="reportList">
          <div v-for="(item,index) in arr" :key="index">
            <div class="title">{{item.title}}</div>
            <div v-if="item.isReport">
              <div style="padding-left:30px;">
                <span v-html="editItem[item.name]?editItem[item.name]:'暂无数据'"></span>
              </div>
            </div>
            <div v-else class="p10">
              <span v-if="editItem[item.name]">{{editItem[item.name]}}</span>
              <span v-else>暂无数据</span>
            </div>

            <div class="report" v-if="item.isReport">点评：{{editItem[item.Reportname]}}</div>
          </div>
          <div>
            <strong class="mr">报告得分：</strong>
            <span class="report">{{editItem.ExpReportScore}}</span>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import * as homeConst from "../../../apiconfig/index.js";
import * as homeApi from "../../../api/teacher-api.js";
import { setInterval } from "timers";
import "../../../assets/js/jquery.min.js";
import saveAs from "file-saver";
import "../../../assets/js/jquery.wordexport.js";
export default {
  name: "reportManagement",
  data() {
    return {
      fileName: "实验报告统计.csv",
      editItemExl: {
        ClassId: 0,
        ExpID: 0
      },
      showModalExcl: false,
      loading: true,
      columns: [
        //设置表格参数
        { title: "学号", key: "SId", align: "center" },
        { title: "班级", key: "ClassName", align: "center" },
        { title: "学生姓名", key: "UserName", align: "center" },
        { title: "虚拟实验名称", key: "ExpName", align: "center" },
        { title: "虚拟实验考试成绩", key: "ExpScore", align: "center" },
        {
          title: "报告提交状态",
          slot: "IsSubmit",
          key: "IsSubmit",
          align: "center"
        },
        {
          title: "报告评分",
          key: "ExpReportScore",
          align: "center",
          width: "96"
        },
        { title: "最终得分", key: "Score", align: "center", width: "96" },
        { title: "批阅状态", slot: "IsType", align: "center", width: "96" },
        { title: "可选操作", slot: "action", align: "center", width: "96" }
      ],
      listObj: {
        Result: []
      },
      pageData: {
        ClassId: 0,
        ExpID: 0,
        page: 1,
        size: 10
      },
      ClassArr: [],
      ExperimentList: [],
      showModal: false,
      editItem: {},
      showDetails: false,
      activeName: "",
      arr: [
        {
          title: "一、实验目的",
          name: "ExpMD",
          isReport: false
        },
        {
          title: "二、实验原理",
          name: "ExpYL",
          isReport: false
        },
        {
          title: "三、实验要求",
          name: "ExpRequire",
          isReport: false
        },
        {
          title: "四、实验考核标准",
          name: "ExpStandard",
          isReport: false
        },
        {
          title: "五、实验材料（整个综合实验有涉及到的材料都要列出）",
          name: "ExpMaterials",
          Reportname: "ExpMaterialsR",
          isReport: true
        },
        {
          title: "六、实验步骤（详叙每周所做的相关步骤）",
          name: "ExpStep",
          Reportname: "ExpStepR",
          isReport: true
        },
        {
          title: "七、实验数据与记录",
          name: "ExpData",
          Reportname: "ExpDataR",
          isReport: true
        },
        {
          title: "八、实验结果与总结",
          name: "ExpResult",
          Reportname: "ExpResultR",
          isReport: true
        }
      ],
      submitObj: {
        ExpReportId: "",
        ExpReportScore: null,
        ExpMaterialsR: "",
        ExpStepR: "",
        ExpDataR: "",
        ExpResultR: "",
        ExpWholeR: ""
      }
    };
  },
  computed: {
    isCollapsed() {
      return this.$store.state.isCollapsed;
    }
  },
  mounted() {
    this.GetTchClass();
    this.GetExperimentList();
    this.getpageArr();
  },
  watch: {
    $route(to, from) {
      this.pageData.page = 1;
      this.getpageArr();
    }
  },
  methods: {
    downFun() {
      this.showModalExcl = true;
      this.editItemExl.ClassId = 0;
      this.editItemExl.ExpID = 0;
    },
    //导出
    sureEditExl(name) {
      if (this.editItemExl.ClassId == undefined) {
        this.editItemExl.ClassId = 0;
      }
      if (this.editItemExl.ExpID == undefined) {
        this.editItemExl.ExpID = 0;
      }
      homeApi
        .GetAllExpReport({
          ClassId: this.editItemExl.ClassId,
          ExpID: this.editItemExl.ExpID
        })
        .then(res => {
          let blob = new Blob([res], {
            type: "application/vnd.ms-excel"
          }); // 转化为blob对象
          let filename = this.fileName; // 判断是否使用默认文件名
          if (typeof window.navigator.msSaveBlob !== "undefined") {
            window.navigator.msSaveBlob(blob, filename);
          } else {
            var blobURL = window.URL.createObjectURL(blob); // 将blob对象转为一个URL
            var tempLink = document.createElement("a"); // 创建一个a标签
            tempLink.style.display = "none";
            tempLink.href = blobURL;
            tempLink.setAttribute("download", filename); // 给a标签添加下载属性
            if (typeof tempLink.download === "undefined") {
              tempLink.setAttribute("target", "_blank");
            }
            document.body.appendChild(tempLink); // 将a标签添加到body当中
            tempLink.click(); // 启动下载
            document.body.removeChild(tempLink); // 下载完毕删除a标签
            window.URL.revokeObjectURL(blobURL);
          }
        });
    },
    //  获取所有课程
    async GetTchClass(RoomId) {
      this.ClassArr = await homeApi.GetTchClass();
    },
    // 获取所有实验
    async GetExperimentList(RoomId) {
      this.ExperimentList = await homeApi.GetExperimentList({
        Search: ""
      });
    },
    // 获取分页数据
    async getpageArr() {
      this.listObj = await homeApi.GetExpReportList({
        ClassId: this.pageData.ClassId ? this.pageData.ClassId : 0,
        ExpID: this.pageData.ExpID ? this.pageData.ExpID : 0,
        page: this.pageData.page ? this.pageData.page : 1,
        size: this.pageData.size ? this.pageData.size : 10
      });
      this.loading = false;
    },
    // 获取实验报告详情
    async GetExpReportById(ExpReportId) {
      this.editItem = await homeApi.GetExpReportById({
        ExpReportId: ExpReportId
      });
    },
    // 编辑
    showItemFn(row, str) {
      this.showDetails = str;
      this.GetExpReportById(row.ExpReportId);
      this.showModal = true;
    },
    doReport(name) {
      this.activeName = name;
    },
    appendSubmit(name) {
      this.editItem[name] = this.submitObj[name];
      this.activeName = "";
    },
    //确认批阅
    sureEdit() {
      this.submitObj.ExpReportId = this.editItem.ExpReportId;
      homeApi.GetExpReport(this.submitObj).then(res => {
        this.showModal = false;
        this.getpageArr();
      });
    },
    searchById(ClassId, ExpID) {
      this.pageData.ClassId = ClassId;
      this.pageData.ExpID = ExpID;
      this.pageData.page = 1;
      this.getpageArr();
    },
    changePage(page) {
      this.pageData.page = page;
      this.getpageArr();
    },
    exportData() {
      var data = this.listObj.Result;
      this.$refs.table.exportCsv({
        filename: "实验报告统计",
        columns: this.columns.filter((col, index) => index < 8),
        data: data
      });
    },
    downloadWord() {
      $("#reportList").wordExport("实验报告");
    }
  }
};
</script>

<style scoped>
</style>